import { StarIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export interface Testimonial {
  content: string;
  author: string;
  role: string;
  company: string;
  rating: number;
}

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export function TestimonialCard({ testimonial }: TestimonialCardProps) {
  return (
    <Card className="h-full w-full">
      <CardContent className="p-6 flex flex-col h-96">
        <div className="flex mb-4 text-primary">
          {[...Array(5)].map((_, i) => (
            <StarIcon
              key={i}
              className={`h-5 w-5 ${
                i < testimonial.rating ? "fill-primary" : "fill-muted"
              }`}
              strokeWidth={0}
            />
          ))}
        </div>
        <blockquote className="text-lg mb-6 overflow-y-auto flex-grow">
          "{testimonial.content}"
        </blockquote>
        <div className="mt-auto pt-4 border-t">
          <div className="font-semibold">{testimonial.author}</div>
          <div className="text-sm text-muted-foreground">
            {testimonial.role}, {testimonial.company}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
